/* Five chats for the docked Zana panel. They live in this browser, keyed by
   school and person, and they are written the moment a word is typed or she
   answers. The model only ever sees the turns of the chat that is open. */

export const MAX_CHATS = 5;

export interface ZChatMsg {
  from: 'you' | 'zana';
  text: string;
  at: number;
  headline?: string;
  facts?: string[];
  note?: string | null;
  sources?: { label: string; page: string; search?: string }[];
  /** Owner's mark on this answer. Kept with the chat so the next turn can say so. */
  rating?: 'good' | 'bad';
}

export interface ZChat {
  id: string;
  title: string;
  draft: string;
  messages: ZChatMsg[];
  updatedAt: number;
}

function storageKey(org: string, uid: string) {
  return `trasse.zana.chats.v1:${org}:${uid}`;
}

export function newChat(now = Date.now()): ZChat {
  return { id: `c${now.toString(36)}${Math.random().toString(36).slice(2, 6)}`, title: 'New chat', draft: '', messages: [], updatedAt: now };
}

export function titleOf(messages: ZChatMsg[], draft = ''): string {
  const first = messages.find((m) => m.from === 'you' && m.text.trim())?.text || draft.trim();
  if (!first) return 'New chat';
  const t = first.replace(/\s+/g, ' ');
  return t.length > 28 ? `${t.slice(0, 27)}…` : t;
}

export function loadChats(org: string, uid: string): ZChat[] {
  if (!org || !uid) return [];
  try {
    const raw = localStorage.getItem(storageKey(org, uid));
    const parsed = raw ? JSON.parse(raw) as ZChat[] : [];
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((c) => c && typeof c.id === 'string').slice(0, MAX_CHATS);
  } catch {
    return [];
  }
}

export function writeChats(org: string, uid: string, chats: ZChat[]): void {
  if (!org || !uid) return;
  try {
    const next = [...chats].sort((a, b) => b.updatedAt - a.updatedAt).slice(0, MAX_CHATS);
    localStorage.setItem(storageKey(org, uid), JSON.stringify(next));
  } catch { /* private mode — the open chat still works in memory */ }
}
